export const environment = {
  USEndpoint: 'https://api-dev.tetherall.io/client/',
  CAEndpoint: 'https://api-dev.tetherall.io/client/',
  buildNumber: "29883769",  
  versionNumber: "5.4.11",  
  environment_deploy: 'dev',
  raygunApiKey: '19Ef2ju2ppmbEe8xOPBOA',
  posthogToken: 'phc_c1PYl38YxEtczRCgWF3CkGLrntfy1rqgVPRDS9Sror9',
  authResultKey: '505c9581-5a1c-444e-abfb-c01ae8237da0',
  biometricsEmailKey: '2ab1d3f1-dbd0-48e0-a260-2040600b9010',
  rememberEmailKey: '448fdf2a-2277-493d-b906-297ca5951c93',
  vaultKey: 'fb511dcc-c1c2-4aee-8194-f0abbeadccce',
  loginKey: '933ee460-fb6d-4d05-8114-4bcc2b449fdc',
  cryptoKey: 'b2067d21-9cbd-4b7c-acb1-4debad1c90c1',
};
